import React from "react";
import { SCL_FLOWER_MARK } from "../data/assets";

// Uses the real SCL flower-only logo. Rendered inside a white circular container
// where needed to hide the raster JPG's white background.
export default function PetalLogo({ size = 96, className = "", animated = true }) {
  return (
    <img
      src={SCL_FLOWER_MARK}
      alt="School for Community Learning"
      width={size}
      height={size}
      className={`${animated ? "petal-breathe" : ""} ${className}`}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
      draggable={false}
    />
  );
}
